<template>
  <div class="pb-5 bg-finger">
    <div class="container" style="height: 120px"></div>
  </div>

  <div class="container-fluid" style="margin-top: -4em">
    <div class="card">
      <div class="card-body py-4">
        <h2 class="text-center text-muted fw-bold">{{ user.fullname }}</h2>
        <p class="text-center text-muted m-0">{{ user.email }}</p>
      </div>
    </div>
  </div>

  <div class="container mb-5 pb-3 mt-3">
    <ul class="list-group mb-3 rounded-3">
      <li class="list-group-item d-flex justify-content-start">
        <i class="bi bi-calendar-week text-primary me-2"></i>
        {{ convertDateID(user.birthdate) }}
      </li>
      <li class="list-group-item d-flex justify-content-start">
        <i class="bi bi-phone text-primary me-2"></i>
        {{ user.phone_number }}
      </li>
      <li class="list-group-item d-flex justify-content-between click-effect ripple" @click="changePassword()">
        <span><i class="bi bi-key text-primary me-2"></i> {{ $t('changePassword.title') }}</span>
        <i class="bi bi-chevron-double-right flex-shrink-1"></i>
      </li>
    </ul>

    <ul class="list-group mb-3 rounded-3">
      <li class="list-group-item">
        <div>
          <select class="form-select" v-model="currentLang">
            <option value="en">🇬🇧 English</option>
            <option value="id">🇮🇩 Indonesia</option>
            <option value="zh">🇨🇳 中文</option>
          </select>
        </div>
      </li>
    </ul>

    <ul class="list-group mb-5 rounded-3">
      <li class="list-group-item d-flex justify-content-between click-effect ripple" @click="openPrivacyPolicy">
        <span class="d-flex justify-content-start align-items-center">
          <i class="bi bi-question-circle text-primary me-2 p-0 m-0"></i>
          <p class="p-0 my-1">{{ $t('privacyPolicy') }}</p>
        </span>
        <i class="bi bi-chevron-double-right flex-shrink-1 align-self-center"></i>
      </li>
      <li class="list-group-item d-flex justify-content-between click-effect ripple" @click="openTermsCondition">
        <span class="d-flex justify-content-start align-items-center">
          <i class="bi bi-question-circle text-primary me-2 p-0 m-0"></i>
          <p class="p-0 my-1">{{ $t('termsCondition') }}</p>
        </span>
        <i class="bi bi-chevron-double-right flex-shrink-1 align-self-center"></i>
      </li>
      <li class="list-group-item d-flex justify-content-between click-effect ripple" @click="openContact">
        <span class="d-flex justify-content-start align-items-center">
          <i class="bi bi-telephone-fill text-primary me-2 m-0 p-0"></i>
          <p class="p-0 m-0">
            {{ $t('contactUs') }} <br />
            <small class="text-muted">{{ $t('email') }}, {{ $t('phone') }} (Whatsapp)</small>
          </p>
        </span>
        <i class="bi bi-chevron-double-right flex-shrink-1 align-self-center"></i>
      </li>
    </ul>

    <button
      class="d-flex align-items-center justify-content-center gap-2 btn btn-primary rounded-pill w-100"
      @click="logout">
      {{ $t('signout') }} <i class="bi bi-box-arrow-right"></i>
    </button>
  </div>

  <BottomNav />
</template>

<script>
import axios from 'axios'
import BottomNav from '../components/BottomNav'
import Swal from 'sweetalert2'
import { loadLocaleMessages } from '../i18n'

export default {
  name: 'Profile',
  components: { BottomNav },
  mounted() {
    document.body.style.backgroundColor = '#EEEEEE'
  },
  unmounted() {
    document.body.style.backgroundColor = '#FFFFFF'
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
    currentLang: {
      get() {
        return this.$store.getters.currentLocale
      },
      async set(lang) {
        this.$store.dispatch('setLocale', lang)
        await loadLocaleMessages(lang)
      },
    },
  },
  methods: {
    openContact() {
      this.$router.push('/contact')
    },
    openPrivacyPolicy() {
      Swal.fire({
        title: this.$t('confirmation.title'),
        showCancelButton: true,
        showConfirmButton: true,
        text: this.$t('confirmation.prompt', { optional: this.$t('externalLink.prompt') }),
        confirmButtonText: this.$t('confirmation.yes'),
        cancelButtonText: this.$t('confirmation.cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://priadi.id/en/privacy-policy', '_blank')
        }
      })
    },
    openTermsCondition() {
      Swal.fire({
        title: this.$t('confirmation.title'),
        showCancelButton: true,
        showConfirmButton: true,
        text: this.$t('confirmation.prompt', { optional: this.$t('externalLink.prompt') }),
        confirmButtonText: this.$t('confirmation.yes'),
        cancelButtonText: this.$t('confirmation.cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://priadi.id/en/terms-and-conditions', '_blank')
        }
      })
    },
    changePassword() {
      this.$router.push('/change_password')
    },
    async logout() {
      try {
        await axios.post('/api/logout', {}, { withCredentials: true })
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        this.$store.dispatch('setAuth', false)
        this.$store.dispatch('setUser', { id: null, email: null })
        this.$router.push('/')
      }
    },
    convertDateID(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      const monthName = this.$t(`months.${month}`)
      return `${day} - ${monthName} - ${year}`
    },
  },
}
</script>

<style scoped>
.bg-finger {
  background: #08a0f1 url('/img/fpimageup.png');
  background-size: cover;
}
</style>
